import React, { useState, useEffect, useContext } from "react";
import './leftDetails.scss';
import { FaPencil, FaStar } from "react-icons/fa6";
import { TiStarFullOutline, TiStarHalfOutline, TiStarOutline } from "react-icons/ti";
import { TbUser } from "react-icons/tb";
import { PiBriefcaseLight, PiChairLight } from "react-icons/pi";
import { LuDownload } from "react-icons/lu";
import { HiringTimeline } from "./HiringTimeline";
import { useParams } from 'react-router-dom';
import candidateApi from "../../services/candidateApi";
import { AuthContext } from "../../context/AuthContext";
import masterApi from "../../services/masterApi";
import { toast } from "react-toastify";
import { MdBlockFlipped, MdOutlineMoreHoriz } from "react-icons/md";
import ownIcon from '../../assets/images/icon.png';


export const LeftDetails = () => {
  let { id } = useParams();
  const [candidateData, setCandidateData] = useState(null);
  const [assessmentDetails, setAssessmentDetails] = useState([]);
  const [averageRatings, setAverageRatings] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const { candidateIdValue, setCandidateIdValue } = useContext(AuthContext);
  const [candidateDetails, setCandidateDetails] = useState([]);
  const { setReloadDataRat } = useContext(AuthContext);
  const BASE_URL = process.env.REACT_APP_API_URL
  const fetchData = async () => {
    try {
      if (!id) {
        id = candidateIdValue;
      }
      const response = await candidateApi.getCandidateById(id); // Call API with the ID
      if (response?.data) {
        setCandidateData(response.data);
        console.log("Fetched Data:", response.data);
      }
    } catch (error) {
      toast.error("Error fetching candidate details", {
        position: "top-right",
        autoClose: 2000,
      });
      console.error("Error fetching candidate details:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [id]);
  const handleDownload = async () => {
    const fileUrl = `/candidate/download-resume/${candidateData.id}`;
    try {
      // Make the API call to fetch the file
      //const response = await get(fileUrl);
      const response = await masterApi.getcandidateResume(candidateData.id);
      // Create a blob from the response data
      const fileBlob = new Blob([response.data], { type: 'application/pdf' }); // You can adjust MIME type
      const fileUrl = window.URL.createObjectURL(fileBlob);
      // Create an anchor tag to trigger the download
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = candidateData.firstName + "_" + candidateData.lastName + "_resume.pdf"; // Customize the download filename
      link.click(); // Trigger the download
    } catch (error) {
      toast.error("Error downloading file", {
        position: "top-right",
        autoClose: 2000,
      });
      console.error("Error downloading file:", error);
    }
  };
  const fetchJobs = async () => {
    try {
      if (!id) {
        id = candidateIdValue;
      }
      const response = await candidateApi.getJobsByCandidate(id);
      console.log("API Response:", response?.data);
      if (response?.data?.length > 0) {
        setCandidateDetails(response.data);
        // setSelectedJobId(response.data[0].jobId);  
        const maxJob = response.data.reduce((max, job) =>
          job.jobId > max.jobId ? job : max
        );
        setSelectedJobId(maxJob.jobId);
      }
    } catch (error) {
      toast.error("Error fetching candidate job details", {
        position: "top-right",
        autoClose: 2000,
      });
      console.error("Error fetching candidate job details:", error);
    }
  };
  useEffect(() => {
    fetchJobs();
  }, [id]);
  const loadDetails = async () => {
    try {
      if (!id) {
        id = candidateIdValue;
      }
      const jobId = selectedJobId;
      const response = await candidateApi.fetchAssessmentWithRatings(id, jobId);
      const avgRatings = response?.data?.averageRatings ? Object.values(response.data.averageRatings) : [];
      setAverageRatings(avgRatings);
    } catch (error) {
      toast.error("Error fetching average ratings details", {
        position: "top-right",
        autoClose: 2000,
      });
      console.error("Error fetching averageRatings details:", error);
    }
  };
  useEffect(() => {
    if (setReloadDataRat) {
      setReloadDataRat(() => loadDetails); // ✅ Store `loadDetails` in context
    }
    loadDetails(); // ✅ Load details initially
  }, [id, selectedJobId]);
  // Calculate overall rating
  const calculateOverallRating = () => {
    if (averageRatings.length === 0) return 0;
    const totalRating = averageRatings.reduce((acc, rating) => acc + parseFloat(rating.averageRating), 0);
    return (totalRating / averageRatings.length).toFixed(2);  // Ensures consistency
  };
  const renderStars = (rating) => {
    const numericRating = parseFloat(rating);
    const fullStars = Math.floor(numericRating);
    const decimalPart = numericRating - fullStars;
    const halfStars = decimalPart >= 0.5 ? 1 : 0;
    const emptyStars = 5 - fullStars - halfStars;
    return (
      <>
        {[...Array(fullStars)].map((_, idx) => (
          <TiStarFullOutline key={`full-${idx}`} className="starfull" />
        ))}
        {halfStars === 1 && <TiStarHalfOutline className="starhalf" />}
        {[...Array(emptyStars)].map((_, idx) => (
          <TiStarOutline key={`empty-${idx}`} className="starempty" />
        ))}
      </>
    );
  };
  const overallRating = calculateOverallRating();
  return (
    <section className="candidate-details-left">
      {candidateData ? (
        <>
          <div className="name-dp-info d-flex gap-2 mb-4">
            {/* <div className="dp-holder position-relative d-flex align-items-center"> */}
            {/* Show default icon if there are no dp */}
            {/* <span><TbUser /></span> */}
            {/* Show uploaded image preview */}
            {/* <img src={dummy} alt="ZeaCruit" /> */}
            {/* <span className="featured"><FaStar /></span> */}
            {/* </div> */}
            <div className="dp-holder position-relative d-flex align-items-center">
              {candidateData.profileImagePath ? (
                <img
                  src={`${BASE_URL}/${candidateData.profileImagePath}`}
                  alt="Profile"
                />
              ) : (
                <span className="default-icon"><TbUser /></span>
              )}

            </div>
            <div className="right-info">
              <h5 className="mb-1">{candidateData.firstName} {candidateData.lastName} </h5>
              <p className="mb-2"><span>{candidateData.currentDesignation}</span><span>{candidateData.title}</span></p>
              <div className="d-flex gap-2 align-items-center justify-content-between flex-wrap">
                <div className="status primary">
                  {candidateData.recordStatus}
                </div>
                <div className="d-flex gap-1 align-items-center badge-holder">
                  {Array.isArray(candidateData.tags) && candidateData.tags.length > 0 ? (
                    candidateData.tags.map((tagId, idx) => {
                      if (tagId === 4) return <span key={tagId} className="featured in-bench" title={"In Bench"}><PiChairLight /></span>;
                      if (tagId === 3) return <span key={tagId} className="featured" title={"Featured"}><FaStar /></span>;
                      if (tagId === 2) return <span key={tagId} className="featured blacklist" title={"Blacklist"}><MdBlockFlipped /></span>;
                      if (tagId === 1) return (
                        <span key={tagId} className="featured own" title={"Zealogics"}>
                          <img src={ownIcon} alt="Profile" />
                        </span>
                      );
                      if (tagId > 4) return (
                        <span key={tagId} className="featured other" title={"Other"}>
                          <MdOutlineMoreHoriz />
                        </span>
                      );
                      return null;
                    })
                  ) : (
                    <span className="featured" title={"Featured"}></span>
                  )}
                    {/* <span className="featured in-bench" title={"In Bench"}><PiChairLight /> </span>
                    <span className="featured other" title={"Other"}><MdOutlineMoreHoriz /> </span> */}

                </div>
                <div>
                  <div className="d-flex exp-holder gap-1 align-items-center">
                    <PiBriefcaseLight /> <span>{`${candidateData.experienceInYears || 0}.${candidateData.experienceInMonths || 0}`} Yrs</span>
                  </div>
                </div>
              </div>


            </div>
          </div>
          <div className="postion-info position-relative mb-4">
            {/* <button className="plain-btn">
          <FaPencil />
        </button> */}
            <label className="form-label" >
              Mapped to
            </label>
            <select className="form-select plain-select" disabled>
              <option selected> {Array.isArray(candidateData.candidatejobmapping) && candidateData.candidatejobmapping.length > 0
                ? candidateData.candidatejobmapping.join(', ')
                : 'Not Yet'}</option>
              {/* <option selected>Sr.Front-End Developer</option>
          <option >Sr.UI/UX Designer</option> */}
            </select>
          </div>
          <div className="rating-info d-flex align-items-center gap-2 mb-3">
            <div>
              <label className="form-label mb-0" >
                Overall Rating
              </label>
              <div className="rating d-flex gap-3 align-items-center">
                <div className="stars">
                  {/* <TiStarFullOutline className="starfull"/>
                <TiStarFullOutline className="starfull"/>
                <TiStarFullOutline className="starfull"/>
                <TiStarHalfOutline className="starhalf"/>
                <TiStarOutline /> */}
                  {renderStars(overallRating)}
                </div>
                <span>
                  <span>{parseFloat(overallRating).toFixed(1)}</span> <em>/</em><span>5</span>
                </span>
              </div>
            </div>
            {/* <button className="ms-auto">
              Resume.pdf <LuDownload />
            </button> */}

            {/* <a href={`${BASE_URL}/candidate/download-resume/${candidateData.id}`} download>
  <button>Download Resume</button>
</a> */}

            {/* <button className="ms-auto" onClick={handleDownload}>Download Resume</button> */}
            {/* <button className="ms-auto">
          <a
            href={`${BASE_URL}/candidate/download-resume/${candidateData.id}`}
            download="Resume.pdf"
          >
            Resume.pdf <LuDownload />
          </a>
        </button> */}

            <button className="ms-auto" onClick={handleDownload}>
              Resume <LuDownload />
            </button>



          </div>
          <div className="d-flex gap-1 skill-holder mb-4 pt-4">
            {candidateData.skillName && candidateData.skillName.length > 0 ? (
              candidateData.skillName.map((skillName, index) => (
                <span key={index} >{skillName}</span>
              ))
            ) : (
              <span>No skills available</span>
            )}

          </div>
          <div className="timeline-holder pt-4">
            <HiringTimeline candidateId={id} />
          </div>
        </>
      ) : (
        <p>Loading candidate data...</p> // Loading state when the data is not fetched yet
      )}
    </section>
  );
}

